import catalog from "./catalog.json";

export const CATALOG = catalog;
export const PAGES = Array.isArray(catalog?.pages) ? catalog.pages : [];
export const PAGE_BY_PATH = Object.fromEntries(PAGES.map((p) => [p.path, p]));
export const pagesOfType = (t) => PAGES.filter((p) => p.type === t);

export const BRAND = "Lucky Taxi Service";
export const OWNER = "Lucky Choudhary";
export const PHONE_DISPLAY = "096602 80530";
export const PHONE_TEL = "+919660280530";
export const EMAIL = "luckychoudhary4838@gmail.com";
export const INSTAGRAM = "https://www.instagram.com/taxi_service_in_jodhpur";
export const SITE_URL = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");
export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const waLink = (text = "Hi Lucky Taxi Service, I want to book a taxi.") =>
  `https://wa.me/${PHONE_TEL.replace("+", "")}?text=${encodeURIComponent(text)}`;

export const OFFICE_LIST = ["jodhpur", "jaisalmer", "udaipur", "jaipur"].map((k) => ({
  key: k,
  ...(catalog?.offices?.[k] || {}),
  path: `/taxi-service-in-${k}`,
  map: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(catalog?.offices?.[k]?.address || k)}`,
  embed: `https://www.google.com/maps?q=${encodeURIComponent(catalog?.offices?.[k]?.address || k)}&output=embed`,
}));

const IMG = {
  jaipur: ["u", "photo-1650530777057-3a7dbc24bf6c", "Hawa Mahal palace facade in Jaipur"],
  amber: ["u", "photo-1599661046289-e31897846e41", "Amber Fort ramparts above Jaipur"],
  jodhpur: ["u", "photo-1602643454724-21d5a40722db", "Blue houses below Mehrangarh Fort in Jodhpur"],
  udaipur: ["u", "photo-1633702738734-443da2c18f3c", "Lake palace and ghats in Udaipur"],
  suv: ["u", "photo-1758223165251-70e3f82e4752", "White SUV taxi on an open highway"],
  highway: ["u", "photo-1701764558596-3fcf413463d0", "Open highway through the Rajasthan desert"],
  jodhpurFort: ["u", "photo-1669548329838-45008f9a45fc", "Mehrangarh Fort above the old city of Jodhpur at sunset"],
  jaisalmerFort: ["u", "photo-1677251486565-8ebade3b1cc4", "Carved golden sandstone haveli in Jaisalmer"],
  desert: ["u", "photo-1564188537512-f6bd010d1e2a", "Thar desert dunes at sunset"],
  camel: ["u", "photo-1697464026024-046547ebd141", "Camel safari across the dunes near Jaisalmer"],
  bikaner: ["p", "31339268", "Junagarh Fort in Bikaner"],
  pushkar: ["p", "19160122", "Pushkar Lake ghats with reflections"],
  mountabu: ["u", "photo-1676370422466-9530043ee359", "Lake surrounded by Aravalli hills near Mount Abu"],
  ranthambore: ["u", "photo-1586617356423-52763004deac", "Tiger walking on a forest track in Ranthambore"],
  safari: ["u", "photo-1725990076174-a3448eb86e76", "Safari vehicle on a dusty forest road"],
  chittorgarh: ["p", "36750734", "Vijay Stambh victory tower at Chittorgarh Fort"],
  sedan: ["u", "photo-1714502524998-e8ea4dd3781d", "White sedan car parked on a city street"],
  luxury: ["u", "photo-1759002369921-ba54006bff01", "Black luxury sedan with headlights on"],
  palace: ["u", "photo-1777707460785-ecdade7c24db", "Carved sandstone palace courtyard in Rajasthan"],
  musician: ["u", "photo-1782407439539-b86498ab28c4", "Rajasthani folk musician in an orange turban"],
  bus: ["u", "photo-1534011056808-50c1c6082fe7", "White passenger van for group travel"],
  family: ["u", "photo-1756142008330-87dc106322a4", "Family enjoying a road trip by car"],
  drive: ["u", "photo-1484373030460-8de45ac8796d", "Driver on a scenic road trip"],
};

export const imgSrc = (key, w = 1200) => {
  const [kind, id] = IMG[key] || IMG.amber;
  return kind === "u"
    ? `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`
    : `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
};
export const imgAlt = (key) => (IMG[key] || IMG.amber)[2];
export const IMAGE_KEYS = Object.keys(IMG);

// Real customer reviews can be added here; none are shown until provided.
export const REVIEWS = [];
